import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { JOB_API_END_POINT } from '../utils/constant'

const jobSlice = createSlice({
  name: "jobs",
  initialState: {
    jobs: [],
    loading: false,
    error: null,
    message: null,
    singleJob: {},
    filterKeys: {
        keyword: '',
        localisation: '',
        secteur: '',
        contractType: [],
        experience: '',
        education: '',
        level: '',
        limit: 10
    },
    myJobs: [],
    jobCategories: []
  },
  reducers: {
    requestForAllJobs(state, action) {
      state.loading = true;
      state.error = null;
    },
    successForAllJobs(state, action) {
      state.loading = false;
      state.jobs = action.payload;
      state.error = null;
    },
    failureForAllJobs(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    requestForSingleJob(state, action) {
      state.message = null;
      state.error = null;
      state.loading = true;
    },
    successForSingleJob(state, action) {
      state.loading = false;
      state.error = null;
      state.singleJob = action.payload;
    },
    failureForSingleJob(state, action) {
      state.singleJob = state.singleJob;
      state.error = action.payload;
      state.loading = false;
    },
    requestForPostJob(state, action) {
      state.message = null;
      state.error = null;
      state.loading = true;
    },
    successForPostJob(state, action) {
      state.message = action.payload;
      state.error = null;
      state.loading = false;
    },
    failureForPostJob(state, action) {
      state.message = null;
      state.error = action.payload;
      state.loading = false;
    },

    requestForDeleteJob(state, action) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    successForDeleteJob(state, action) {
      state.loading = false;
      state.error = null;
      state.message = action.payload;
    },
    failureForDeleteJob(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },

    requestForMyJobs(state, action) {
      state.loading = true;
      state.myJobs = [];
      state.error = null;
    },
    successForMyJobs(state, action) {
      state.loading = false;
      state.myJobs = action.payload;
      state.error = null;
    },
    failureForMyJobs(state, action) {
      state.loading = false;
      state.myJobs = state.myJobs;
      state.error = action.payload;
    },

    requestForJobCategories(state, action) {
      state.loading = true;
      state.myJobs = [];
      state.error = null;
    },
    successForJobCategories(state, action) {
      state.loading = false;
      state.myJobs = action.payload;
      state.error = null;
    },
    failureForJobCategories(state, action) {
      state.loading = false;
      state.myJobs = state.myJobs;
      state.error = action.payload;
    },

    clearAllErrors(state, action) {
      state.error = null;
      state.loading = false;
      // state.jobs = state.jobs;
    },
    resetJobSlice(state, action) {
      state.error = null;
      state.jobs = state.jobs;
      state.loading = false;
      state.message = null;
      state.myJobs = state.myJobs;
      state.singleJob = {};
    },
  },
});

export const fetchJobs =
//   (location="", category="", keyword = "", per_page=10) =>//per_page
(filterKey) =>
  async (dispatch) => {
    try {
      dispatch(jobSlice.actions.requestForAllJobs());
      let link = JOB_API_END_POINT+"/all?";
      let queryParams = [];
      if (filterKey?.keyword) {
        queryParams.push(`keyword=${filterKey?.keyword}`);
      }
      if (filterKey?.location) {
        queryParams.push(`location=${filterKey?.location}`);
      }
      if (filterKey?.category) {
        queryParams.push(`category=${filterKey?.category}`);
      }
      if (filterKey?.secteur) {
        queryParams.push(`secteur=${filterKey?.secteur}`);
      }

      if (filterKey?.level && filterKey?.level !== "Tous") {
        queryParams.push(`level=${filterKey?.level}`);
      }
      if (filterKey?.experience && filterKey?.experience !== "Tous") {
        queryParams.push(`experience=${filterKey?.experience}`);
      }
      if (Array.isArray(filterKey?.contractType) && filterKey.contractType.length > 0) {
        filterKey.contractType.forEach((type) => {
          queryParams.push(`contractType[]=${encodeURIComponent(type)}`);
        });
      }
      if (filterKey?.limit) {
        queryParams.push(`per_page=${filterKey?.limit}`);
      }
      // if (filterKey?.page) {
        queryParams.push(`page=${filterKey?.page}`);
      // }

      link += queryParams.join("&");
      console.log("requete:",link)
      const response = await axios.get(link);
      console.log("jobs:",response?.data)
      dispatch(jobSlice.actions.successForAllJobs(response?.data));
      dispatch(jobSlice.actions.clearAllErrors());
    } catch (error) {
      console.log("Error while fetching jobs :", error)
      dispatch(jobSlice.actions.failureForAllJobs(error.response?.data?.message));
    }
  };

export const fetchSingleJob = (jobId) => async (dispatch) => {
  dispatch(jobSlice.actions.requestForSingleJob());
  try {
    const response = await axios.get(
      `${JOB_API_END_POINT}/${jobId}`
    )
    console.log("Single Job",response.data)
    dispatch(jobSlice.actions.successForSingleJob(response.data))
    dispatch(jobSlice.actions.clearAllErrors())
  } catch (error) {
    dispatch(jobSlice.actions.failureForSingleJob(error.response?.data?.message));
  }
}

export const postJob = (data) => async (dispatch) => {
  dispatch(jobSlice.actions.requestForPostJob());
  try {
    const response = await axios.post(
      `${JOB_API_END_POINT}/save`,
      data,
      { withCredentials: true, headers: { "Content-Type": "application/json" } }
    );
    dispatch(jobSlice.actions.successForPostJob(response.data.message));
    dispatch(jobSlice.actions.clearAllErrors());
  } catch (error) {
    dispatch(jobSlice.actions.failureForPostJob(error.response.data.message));
  }
};

export const getMyJobs = () => async (dispatch) => {
  dispatch(jobSlice.actions.requestForMyJobs());
  try {
    const response = await axios.get(
      `${JOB_API_END_POINT}/getmyjobs`,
      { withCredentials: true }
    );
    dispatch(jobSlice.actions.successForMyJobs(response.data.myJobs));
    dispatch(jobSlice.actions.clearAllErrors());
  } catch (error) {
    dispatch(jobSlice.actions.failureForMyJobs(error.response.data.message));
  }
};

export const getJobCategories = () => async (dispatch) => {
  dispatch(jobSlice.actions.requestForJobCategories());
  try {
    const response = await axios.get(
      `${JOB_API_END_POINT}/allCategories`,
      { withCredentials: true }
    );
    dispatch(jobSlice.actions.successForJobCategories(response.data.jobCategories));
    dispatch(jobSlice.actions.clearAllErrors());
  } catch (error) {
    dispatch(jobSlice.actions.failureForJobCategories(error.response.data.message));
  }
};

export const deleteJob = (id) => async (dispatch) => {
  dispatch(jobSlice.actions.requestForDeleteJob());
  try {
    const response = await axios.delete(
      `${JOB_API_END_POINT}/delete/${id}`,
      { withCredentials: true }
    );
    dispatch(jobSlice.actions.successForDeleteJob(response.data.message));
    dispatch(clearAllJobErrors());
  } catch (error) {
    dispatch(jobSlice.actions.failureForDeleteJob(error.response.data.message));
  }
};

export const clearAllJobErrors = () => (dispatch) => {
  dispatch(jobSlice.actions.clearAllErrors());
};

export const resetJobSlice = () => (dispatch) => {
  dispatch(jobSlice.actions.resetJobSlice());
};

export default jobSlice.reducer;